import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function useAddProduct(access, slots) {
  const nav = useNavigate();
  return () => {
    if (access === "restricted") {
      toast.info("Choose a package to start listing your products");
      nav("/seller/subscription");
    } else if ((slots?.available_slots ?? 0) <= 0) {
      toast.info("All your product slots are used. Buy an add-on package to list more");
      nav("/seller/subscription");
    } else {
      nav("/seller/add-product");
    }
  };
}
